import { render, staticRenderFns } from "./Sliders.vue?vue&type=template&id=906014a0&scoped=true&"
import script from "./Sliders.vue?vue&type=script&lang=js&"
export * from "./Sliders.vue?vue&type=script&lang=js&"
import style0 from "./Sliders.vue?vue&type=style&index=0&id=906014a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "906014a0",
  null
  
)

export default component.exports